import { IHxTrainingPage } from 'interfaces/IHxTraining';
import { api } from './api';

export const hxTrainingApi = api.injectEndpoints({
  endpoints: (build) => ({
    getHxTrainingPage: build.query<IHxTrainingPage, void>({
      query: () => ({
        url: `HxTrainingPage`,
      }),
    }),
  }),
});

export const { useGetHxTrainingPageQuery } = hxTrainingApi;

export const {
  endpoints: { getHxTrainingPage },
} = hxTrainingApi;
